import { emeraldRequest } from '../../common/api/emerald-request';
import { popEmeraldModal } from '../../common/emerald-modal-manager/emerald-modal-manager';
import { store } from '../../common/redux/configure-store';
import { NotificationActions } from '../../common/redux/reducers/notification-reducer';
import { showNotificationDialog } from '../notifications';
import { INotification } from '../../common/interfaces/dtos/INotification';
import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from '../../common/interfaces/requests/EmeraldRequestParams';
import XLRLogger from 'src/common/helpers/logger';

export const popupNotifications = (isStartup?: boolean): void => {
  if (!isStartup || store.getState().notification.notifications.length) {
    showNotificationDialog({
      onClose: popEmeraldModal,
      onCheck: dismissNotification,
    });
  }
};

export const dismissNotification = (notificationId: string, instanceId: string): void => {
  const axiosConfig: AxiosRequestConfig = {
    url: '/notification-management/dismiss',
    method: 'POST',
    data: {
      notificationId,
      instanceId,
    },
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  emeraldRequest(emeraldRequestParams)
    .catch(err => {
      XLRLogger.error({
        message: '',
        data: err,
        source: 'notification-actions-handler.ts',
      });
    })
    .finally(() => {
      store.dispatch(NotificationActions.deleteNotification(notificationId, instanceId));
    });
};

export const getPendingNotifications = async (): Promise<void> => {
  const limitNumofTakes: number = 100; //TODO: We need to get this data from the POSConfig
  const clientState: string = 'SignOn';

  const axiosConfig: AxiosRequestConfig = {
    url: '/notification-management/notifications',
    method: 'GET',
    params: {
      clientState,
      count: limitNumofTakes,
    },
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  await emeraldRequest<INotification[]>(emeraldRequestParams)
    .then((notifications: INotification[]): void => {
      store.dispatch(NotificationActions.setNotificationInfo(notifications));
    })
    .catch((err): void => {
      XLRLogger.error({
        message: '',
        data: err,
        source: 'notification-action-handler.ts',
      });
    });
};
